import { render, staticRenderFns } from "./ResetPasswordForTeamMemberDialog.vue?vue&type=template&id=0d42bc48&"
import script from "./ResetPasswordForTeamMemberDialog.vue?vue&type=script&lang=js&"
export * from "./ResetPasswordForTeamMemberDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports